import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const appleAuthRejectionSchema = z.object({
  stage: z.enum(["native_authorize", "session_exchange"]),
  category: z.enum([
    "provider_disabled",
    "audience_mismatch",
    "credential_revoked",
    "network",
    "no_identity_token",
    "unknown",
  ]),
  platform: z.enum(["ios", "android", "web", "unknown"]),
  tokenPresent: z.boolean(),
  noncePresent: z.boolean(),
  authorizationCodePresent: z.boolean(),
});

/**
 * Writes a deliberately credential-free server log for native Apple failures.
 * The schema prevents tokens, authorization codes, names, and email addresses
 * from entering the backend log payload.
 */
export const reportAppleAuthRejection = createServerFn({ method: "POST" })
  .inputValidator((data) => appleAuthRejectionSchema.parse(data))
  .handler(async ({ data }) => {
    console.warn("[apple-auth-backend] rejection", {
      occurred_at: new Date().toISOString(),
      ...data,
    });
    return { recorded: true };
  });